export const AdminPassword = '238462';

export const UrasekaiPassword = 't84GDSRER&8*(YR$*(ewf09_)$T>P$';